export default __webpack_public_path__ + "static/1-8fc11a8450aa3baf488c96e1a0c3eed8.jpeg";